import { useState, useEffect, useCallback } from "react";

const API = "/api";
const fmt = v => new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(v||0);
const fmtN = v => new Intl.NumberFormat("pt-BR").format(v||0);
const COR_ST = {ativo:"#10B981",ativa:"#10B981",trial:"#F59E0B",suspenso:"#EF4444",pago:"#10B981",recebido:"#10B981",pendente:"#F59E0B",agendado:"#3B82F6",vencido:"#EF4444",aberto:"#3B82F6",atrasado:"#EF4444",disponivel:"#10B981",em_uso:"#3B82F6",manutencao:"#F59E0B"};
const LAB_ST = {ativo:"Ativo",ativa:"Ativa",trial:"Trial",suspenso:"Suspenso",pago:"Pago",recebido:"Recebido",pendente:"Pendente",agendado:"Agendado",vencido:"Vencido",aberto:"Aberto",atrasado:"Atrasado",disponivel:"Disponível",em_uso:"Em uso",manutencao:"Manutenção"};
const cs = s => COR_ST[s]||"#6B7280";

const S = {
  page:{background:"#0F172A",minHeight:"100vh",color:"#F1F5F9",fontFamily:"system-ui,sans-serif"},
  card:{background:"#1E293B",borderRadius:12,padding:18,border:"1px solid #334155"},
  th:{textAlign:"left",padding:"7px 10px",color:"#64748B",fontSize:11,fontWeight:600},
  td:{padding:"10px",fontSize:13},
  sb:{width:220,background:"#0A1628",borderRight:"1px solid #1E293B",display:"flex",flexDirection:"column"},
  nav:{display:"flex",alignItems:"center",gap:9,padding:"9px 12px",borderRadius:7,marginBottom:2,cursor:"pointer",fontSize:13},
  inp:{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"9px 11px",color:"#F1F5F9",fontSize:13,boxSizing:"border-box"},
};

const Badge = ({s}) => <span style={{background:cs(s)+"22",color:cs(s),padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{LAB_ST[s]||s}</span>;
const Btn = ({ch,onClick,c="#3B82F6",out,sm,full,style={}}) => <button onClick={onClick} style={{background:out?"transparent":c,color:out?c:"#fff",border:`1px solid ${c}`,borderRadius:7,padding:sm?"5px 12px":"9px 18px",fontSize:sm?12:13,fontWeight:600,cursor:"pointer",width:full?"100%":"auto",...style}}>{ch}</button>;
const Card = ({ch,style={}}) => <div style={{...S.card,...style}}>{ch}</div>;
const Metric = ({label,valor,sub,c="#3B82F6",icon}) => (
  <Card ch={<div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
    <div>
      <div style={{color:"#94A3B8",fontSize:12,marginBottom:4}}>{label}</div>
      <div style={{color:"#F1F5F9",fontSize:22,fontWeight:700}}>{valor}</div>
      {sub&&<div style={{color:"#64748B",fontSize:11,marginTop:3}}>{sub}</div>}
    </div>
    <div style={{width:36,height:36,borderRadius:9,background:c+"22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:17}}>{icon}</div>
  </div>}/>
);
const Campo = ({label,value,onChange,type="text",options,cols}) => (
  <div style={cols?{gridColumn:`span ${cols}`}:{}}>
    <label style={{color:"#94A3B8",fontSize:12,display:"block",marginBottom:4}}>{label}</label>
    {options
      ? <select value={value} onChange={e=>onChange(e.target.value)} style={S.inp}>{options.map(o=><option key={o.v||o} value={o.v||o}>{o.l||o}</option>)}</select>
      : <input value={value||""} onChange={e=>onChange(e.target.value)} type={type} style={S.inp}/>}
  </div>
);
const Modal = ({title,ch,onClose}) => (
  <Card style={{marginBottom:20,borderColor:"#3B82F6",borderWidth:2}} ch={<>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
      <div style={{fontWeight:700,fontSize:15}}>{title}</div>
      <Btn sm out c="#EF4444" onClick={onClose} ch="✕"/>
    </div>
    {ch}
  </>}/>
);
const Tabela = ({cols,rows,empty="Nenhum registro"}) => (
  <table style={{width:"100%",borderCollapse:"collapse"}}>
    <thead><tr style={{borderBottom:"1px solid #334155"}}>{cols.map(c=><th key={c} style={S.th}>{c}</th>)}</tr></thead>
    <tbody>
      {rows.length===0
        ? <tr><td colSpan={cols.length} style={{padding:32,textAlign:"center",color:"#475569"}}>{empty}</td></tr>
        : rows
      }
    </tbody>
  </table>
);
const Logo = () => (
  <div style={{display:"flex",alignItems:"center",gap:10}}>
    <div style={{width:32,height:32,background:"linear-gradient(135deg,#3B82F6,#8B5CF6)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:"#fff",fontSize:15}}>M</div>
    <span style={{fontWeight:700,fontSize:16}}>MultiERP <span style={{color:"#3B82F6"}}>Pro</span></span>
  </div>
);

// ── LANDING ──────────────────────────────────────────────────────────────────
function Landing({onGo}) {
  const PLANOS=[
    {id:"starter",nome:"Starter",preco:99,cor:"#3B82F6",limite:"500 clientes",mods:["Clientes","Financeiro","Relatórios"]},
    {id:"pro",nome:"Pro",preco:199,cor:"#8B5CF6",limite:"5.000 clientes",mods:["Clientes","Financeiro","Contratos","Estoque","Frota"],pop:true},
    {id:"enterprise",nome:"Enterprise",preco:399,cor:"#F59E0B",limite:"Ilimitado",mods:["Todos os módulos","Multi-usuários","API","Suporte prioritário"]},
  ];
  return (
    <div style={S.page}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"18px 48px",borderBottom:"1px solid #1E293B"}}>
        <Logo/>
        <div style={{display:"flex",gap:10}}>
          <Btn out onClick={onGo} ch="Entrar"/>
          <Btn onClick={onGo} ch="Começar grátis"/>
        </div>
      </div>
      <div style={{textAlign:"center",padding:"70px 48px 50px"}}>
        <div style={{display:"inline-block",background:"#3B82F622",color:"#3B82F6",padding:"5px 14px",borderRadius:20,fontSize:12,fontWeight:600,marginBottom:22}}>✦ ERP completo · Qualquer segmento</div>
        <h1 style={{fontSize:46,fontWeight:800,lineHeight:1.1,maxWidth:640,margin:"0 auto 18px"}}>
          Gerencie sua empresa com{" "}
          <span style={{background:"linear-gradient(90deg,#3B82F6,#8B5CF6)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>inteligência</span>
        </h1>
        <p style={{color:"#94A3B8",fontSize:16,maxWidth:520,margin:"0 auto 36px",lineHeight:1.6}}>Clientes, financeiro, estoque, frota e contratos em um único sistema. Simples, rápido e moderno.</p>
        <div style={{display:"flex",gap:14,justifyContent:"center"}}>
          <Btn onClick={onGo} style={{padding:"13px 30px",fontSize:15}} ch="Testar 14 dias grátis"/>
          <Btn out onClick={onGo} c="#94A3B8" style={{padding:"13px 30px",fontSize:15}} ch="Ver demonstração"/>
        </div>
        <p style={{color:"#475569",fontSize:12,marginTop:14}}>Sem cartão de crédito · Cancele quando quiser</p>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,maxWidth:900,margin:"0 auto",padding:"0 48px 40px"}}>
        {[["👥","Clientes","Cadastro completo com histórico e documentos."],["💰","Financeiro","Contas a receber, pagar e fluxo de caixa."],["📋","Contratos","Vencimentos e renovações automáticas."],["📦","Estoque","Entradas/saídas com alertas de mínimo."],["🚗","Frota","Veículos, manutenções e abastecimentos."],["📊","Relatórios","Dashboards em tempo real + exportação."]].map(([ic,t,d])=>(
          <Card key={t} style={{}} ch={<><div style={{fontSize:26,marginBottom:10}}>{ic}</div><div style={{fontWeight:700,marginBottom:6,fontSize:14}}>{t}</div><div style={{color:"#94A3B8",fontSize:13,lineHeight:1.5}}>{d}</div></>}/>
        ))}
      </div>
      <div style={{padding:"40px 48px",textAlign:"center"}}>
        <h2 style={{fontSize:30,fontWeight:800,marginBottom:8}}>Planos e preços</h2>
        <p style={{color:"#94A3B8",marginBottom:32}}>Escolha o plano ideal para seu negócio</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:18,maxWidth:860,margin:"0 auto"}}>
          {PLANOS.map(p=>(
            <div key={p.id} style={{background:p.pop?"linear-gradient(135deg,#1E3A5F,#2D1B69)":"#1E293B",border:`2px solid ${p.pop?p.cor:"#334155"}`,borderRadius:14,padding:26,position:"relative"}}>
              {p.pop&&<div style={{position:"absolute",top:-11,left:"50%",transform:"translateX(-50%)",background:p.cor,color:"#fff",fontSize:11,fontWeight:700,padding:"3px 14px",borderRadius:20}}>MAIS POPULAR</div>}
              <div style={{color:p.cor,fontWeight:700,fontSize:13,marginBottom:6}}>{p.nome}</div>
              <div style={{fontSize:32,fontWeight:800,marginBottom:3}}>R$ {p.preco}<span style={{fontSize:13,color:"#94A3B8"}}>/mês</span></div>
              <div style={{color:"#64748B",fontSize:12,marginBottom:18}}>{p.limite}</div>
              {p.mods.map(m=><div key={m} style={{color:"#94A3B8",fontSize:13,padding:"3px 0"}}>✓ {m}</div>)}
              <Btn onClick={onGo} c={p.cor} full style={{marginTop:20,padding:"11px 0"}} ch="Começar"/>
            </div>
          ))}
        </div>
      </div>
      <div style={{textAlign:"center",padding:14,color:"#334155",fontSize:12,borderTop:"1px solid #1E293B"}}>© 2026 MultiERP Pro · Next Networks · erp.nextnetworking.com.br</div>
    </div>
  );
}

// ── LOGIN ────────────────────────────────────────────────────────────────────
function Login({onLogin}) {
  const [email,setEmail] = useState("admin@erp.local");
  const [senha,setSenha] = useState("");
  const [erro,setErro] = useState("");
  const [loading,setLoading] = useState(false);

  const entrar = async () => {
    setLoading(true); setErro("");
    try {
      const r = await fetch(API+"/auth/login",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email,senha})});
      const d = await r.json();
      if(r.ok) onLogin(d);
      else setErro(d.error||"Credenciais inválidas");
    } catch(e){ setErro("Erro de conexão com a API"); }
    setLoading(false);
  };

  return (
    <div style={{...S.page,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{width:380}}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{width:48,height:48,background:"linear-gradient(135deg,#3B82F6,#8B5CF6)",borderRadius:11,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:20,margin:"0 auto 14px",color:"#fff"}}>M</div>
          <div style={{fontWeight:700,fontSize:20}}>MultiERP <span style={{color:"#3B82F6"}}>Pro</span></div>
          <div style={{color:"#64748B",fontSize:13,marginTop:3}}>Acesse sua conta</div>
        </div>
        <Card ch={<>
          <div style={{marginBottom:14}}>
            <label style={{color:"#94A3B8",fontSize:12,display:"block",marginBottom:5}}>Email</label>
            <input value={email} onChange={e=>setEmail(e.target.value)} style={S.inp}/>
          </div>
          <div style={{marginBottom:16}}>
            <label style={{color:"#94A3B8",fontSize:12,display:"block",marginBottom:5}}>Senha</label>
            <input value={senha} onChange={e=>setSenha(e.target.value)} type="password" onKeyDown={e=>e.key==="Enter"&&entrar()} style={S.inp}/>
          </div>
          {erro&&<div style={{color:"#EF4444",fontSize:12,marginBottom:12}}>⚠️ {erro}</div>}
          <Btn onClick={entrar} full style={{padding:"11px 0",fontSize:14}} c={loading?"#475569":"#3B82F6"} ch={loading?"Entrando...":"Entrar"}/>
        </>}/>
        <div style={{textAlign:"center",marginTop:14,color:"#475569",fontSize:12}}>
          Sem conta? <span onClick={onLogin} style={{color:"#3B82F6",cursor:"pointer"}}>Criar trial grátis</span>
        </div>
      </div>
    </div>
  );
}

// ── ERP PRINCIPAL ─────────────────────────────────────────────────────────────
function ERP({user,onLogout}) {
  const [empresas,setEmpresas] = useState([]);
  const [empAtual,setEmpAtual] = useState(null);
  const [dados,setDados] = useState(null);
  const [aba,setAba] = useState("dashboard");
  const [modal,setModal] = useState(null);
  const [form,setForm] = useState({});
  const [loading,setLoading] = useState(false);
  const [busca,setBusca] = useState("");

  const f = (k,v) => setForm(p=>({...p,[k]:v}));

  // Carrega lista de empresas
  useEffect(()=>{
    fetch(API+"/empresas").then(r=>r.json()).then(d=>{
      setEmpresas(d);
      if(d.length>0){ setEmpAtual(d[0]); }
    }).catch(()=>{});
  },[]);

  // Carrega dados da empresa ativa
  const carregarDados = useCallback(()=>{
    if(!empAtual) return;
    setLoading(true);
    fetch(API+"/empresa/"+empAtual.id).then(r=>r.json()).then(d=>{
      setDados(d); setLoading(false);
    }).catch(()=>setLoading(false));
  },[empAtual]);

  useEffect(()=>{ carregarDados(); },[carregarDados]);

  const salvarCol = async (col,item) => {
    await fetch(API+"/empresa/"+empAtual.id+"/"+col,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(item)});
    carregarDados(); setModal(null); setForm({});
  };
  const atualizarItem = async (col,id,patch) => {
    await fetch(API+"/empresa/"+empAtual.id+"/"+col+"/"+id,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(patch)});
    carregarDados();
  };
  const deletarItem = async (col,id) => {
    await fetch(API+"/empresa/"+empAtual.id+"/"+col+"/"+id,{method:"DELETE"});
    carregarDados();
  };

  const cr = dados?.cr||[];
  const cp = dados?.cp||[];
  const clientes = dados?.clientes||[];
  const fornecedores = dados?.fornecedores||[];
  const prod = dados?.prod||[];
  const estoque = dados?.estoque||[];
  const frota = dados?.frota||[];
  const usuarios = dados?.usuarios||[];
  const faturas = dados?.faturas||[];
  const conexoes = dados?.conexoes||[];
  const planos_det = dados?.planos_detalhados||[];
  const bancos = dados?.bancos||[];
  const tr = dados?.tr||[];

  const totCR = cr.filter(x=>x.st==="pendente").reduce((a,x)=>a+(x.val||0),0);
  const totCP = cp.filter(x=>x.st==="pendente"||x.st==="agendado").reduce((a,x)=>a+(x.val||0),0);
  const totVencCR = cr.filter(x=>x.st==="vencido").reduce((a,x)=>a+(x.val||0),0);
  const cliAtivos = clientes.filter(c=>c.ativo).length;
  const estBaixo = estoque.filter(e=>e.tipo==="entrada").length;
  const veicDisp = frota.filter(v=>v.st==="disponivel").length;

  const MENUS=[["dashboard","📊","Dashboard"],["clientes","👥","Clientes"],["fornecedores","🏭","Fornecedores"],["cr","💰","Contas a Receber"],["cp","💸","Contas a Pagar"],["prod","📦","Produtos"],["estoque","🏪","Estoque"],["frota","🚗","Frota"],["tributos","🧾","Tributos"],["bancos","🏦","Bancos"],["faturas","🧾","Faturas"],["conexoes","🔌","Conexões Técnicas"],["planos_det","📡","Planos Detalhados"],["relatorios","📈","Relatórios"],["usuarios","👤","Usuários"]];

  return (
    <div style={{display:"flex",height:"100vh",...S.page}}>
      {/* Sidebar */}
      <div style={S.sb}>
        <div style={{padding:"14px",borderBottom:"1px solid #1E293B"}}><Logo/></div>
        {/* Seletor de empresa */}
        <div style={{padding:"10px 12px",borderBottom:"1px solid #1E293B"}}>
          <div style={{color:"#64748B",fontSize:10,marginBottom:6,fontWeight:600}}>EMPRESA ATIVA</div>
          <select value={empAtual?.id||""} onChange={e=>{const emp=empresas.find(x=>x.id===e.target.value);setEmpAtual(emp);setAba("dashboard");}} style={{...S.inp,fontSize:12,padding:"6px 8px",borderRadius:6}}>
            {empresas.map(e=><option key={e.id} value={e.id}>{e.n}</option>)}
          </select>
          {empAtual&&<div style={{fontSize:10,color:"#475569",marginTop:4}}>{empAtual.cnpj}</div>}
        </div>
        <nav style={{flex:1,padding:"8px 7px",overflowY:"auto"}}>
          {MENUS.map(([id,ic,lb])=>(
            <div key={id} onClick={()=>{setAba(id);setBusca("");}} style={{...S.nav,background:aba===id?"#1E3A5F":"transparent",color:aba===id?"#3B82F6":"#94A3B8",fontWeight:aba===id?600:400}}>{ic} {lb}</div>
          ))}
        </nav>
        <div style={{padding:"10px 7px",borderTop:"1px solid #1E293B"}}>
          <div style={{...S.nav,color:"#64748B",fontSize:12,marginBottom:4}}>👤 {user?.nome||"Usuário"}</div>
          <div onClick={onLogout} style={{...S.nav,color:"#EF4444",fontSize:13}}>🚪 Sair</div>
        </div>
      </div>

      {/* Conteúdo */}
      <div style={{flex:1,overflow:"auto",padding:24}}>
        {loading&&<div style={{textAlign:"center",padding:40,color:"#64748B"}}>Carregando...</div>}
        {!loading&&<>

        {/* DASHBOARD */}
        {aba==="dashboard"&&(
          <div>
            <div style={{marginBottom:18}}>
              <h1 style={{fontSize:20,fontWeight:800}}>{empAtual?.n||"Dashboard"}</h1>
              <div style={{color:"#64748B",fontSize:12}}>{new Date().toLocaleDateString("pt-BR",{weekday:"long",day:"2-digit",month:"long",year:"numeric"})}</div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:18}}>
              <Metric label="A Receber" valor={fmt(totCR)} sub={cr.filter(x=>x.st==="pendente").length+" títulos"} c="#10B981" icon="📥"/>
              <Metric label="A Pagar" valor={fmt(totCP)} sub={cp.filter(x=>x.st!=="pago").length+" títulos"} c="#EF4444" icon="📤"/>
              <Metric label="Clientes ativos" valor={fmtN(cliAtivos)} sub={clientes.length+" total"} c="#3B82F6" icon="👥"/>
              <Metric label="Vencidos CR" valor={fmt(totVencCR)} sub="Inadimplência" c="#F59E0B" icon="⚠️"/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:18}}>
              <Card ch={<>
                <div style={{fontWeight:700,marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>Contas a Receber (pendentes)</span>
                  <Btn sm onClick={()=>setAba("cr")} ch="Ver todas"/>
                </div>
                {cr.filter(x=>x.st==="pendente").slice(0,5).map(r=>(
                  <div key={r.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 0",borderBottom:"1px solid #1E293B"}}>
                    <div><div style={{fontSize:13,fontWeight:500}}>{r.cli||r.desc}</div><div style={{fontSize:11,color:"#64748B"}}>{r.svc} · Venc. {r.venc}</div></div>
                    <div style={{display:"flex",gap:10,alignItems:"center"}}>
                      <span style={{fontWeight:700,fontSize:13,color:"#10B981"}}>{fmt(r.val)}</span>
                      <Badge s={r.st}/>
                    </div>
                  </div>
                ))}
                {cr.filter(x=>x.st==="pendente").length===0&&<div style={{color:"#475569",textAlign:"center",padding:20}}>Nenhuma conta pendente 🎉</div>}
              </>}/>
              <div style={{display:"flex",flexDirection:"column",gap:14}}>
                <Card ch={<>
                  <div style={{fontWeight:700,marginBottom:10,fontSize:13}}>A Pagar (urgente)</div>
                  {cp.filter(x=>x.st!=="pago").slice(0,4).map(p=>(
                    <div key={p.id} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:"1px solid #1E293B"}}>
                      <span style={{color:"#94A3B8",fontSize:12,maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.forn}</span>
                      <span style={{fontWeight:700,color:"#EF4444",fontSize:12}}>{fmt(p.val)}</span>
                    </div>
                  ))}
                  {cp.filter(x=>x.st!=="pago").length===0&&<div style={{color:"#10B981",fontSize:12,textAlign:"center",padding:10}}>✓ Em dia!</div>}
                </>}/>
                <Card ch={<>
                  <div style={{fontWeight:700,marginBottom:10,fontSize:13}}>Bancos</div>
                  {bancos.map(b=>(
                    <div key={b.id} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:"1px solid #1E293B"}}>
                      <span style={{color:"#94A3B8",fontSize:12}}>{b.banco}</span>
                      <span style={{fontWeight:700,color:"#3B82F6",fontSize:12}}>{fmt(b.saldo)}</span>
                    </div>
                  ))}
                  {bancos.length===0&&<div style={{color:"#475569",fontSize:12,textAlign:"center",padding:10}}>Nenhum banco cadastrado</div>}
                </>}/>
              </div>
            </div>
          </div>
        )}

        {/* CLIENTES */}
        {aba==="clientes"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Clientes</h1><div style={{color:"#64748B",fontSize:12}}>{clientes.length} cadastrados · {cliAtivos} ativos</div></div>
              <div style={{display:"flex",gap:10}}>
                <input value={busca} onChange={e=>setBusca(e.target.value)} placeholder="🔍 Buscar..." style={{...S.inp,width:220}}/>
                <Btn onClick={()=>{setModal("cli");setForm({nome:"",tipo:"PF",doc:"",email:"",tel:"",cep:"",end:"",num:"",bairro:"",cidade:"",uf:"SP",limite:"0,00",obs:"",ativo:true});}} ch="+ Novo"/>
              </div>
            </div>
            {modal==="cli"&&<Modal title={form.id?"Editar cliente":"Novo cliente"} onClose={()=>setModal(null)} ch={<>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <Campo label="Nome/Razão Social" value={form.nome} onChange={v=>f("nome",v)} cols={2}/>
                <Campo label="Tipo" value={form.tipo} onChange={v=>f("tipo",v)} options={["PF","PJ"]}/>
                <Campo label="CPF/CNPJ" value={form.doc} onChange={v=>f("doc",v)}/>
                <Campo label="Email" value={form.email} onChange={v=>f("email",v)}/>
                <Campo label="Telefone" value={form.tel} onChange={v=>f("tel",v)}/>
                <Campo label="CEP" value={form.cep} onChange={v=>f("cep",v)}/>
                <Campo label="Endereço" value={form.end} onChange={v=>f("end",v)}/>
                <Campo label="Número" value={form.num} onChange={v=>f("num",v)}/>
                <Campo label="Bairro" value={form.bairro} onChange={v=>f("bairro",v)}/>
                <Campo label="Cidade" value={form.cidade} onChange={v=>f("cidade",v)}/>
                <Campo label="UF" value={form.uf} onChange={v=>f("uf",v)}/>
                <Campo label="Limite crédito" value={form.limite} onChange={v=>f("limite",v)}/>
                <Campo label="Observações" value={form.obs} onChange={v=>f("obs",v)} cols={2}/>
              </div>
              <Btn onClick={()=>salvarCol("clientes",form)} c="#10B981" ch="✓ Salvar"/>
            </>}/>}
            <Card ch={<Tabela
              cols={["Nome","Tipo","Doc","Email","Cidade","Limite","Status",""]}
              rows={clientes.filter(c=>!busca||c.nome?.toLowerCase().includes(busca.toLowerCase())||c.doc?.includes(busca)).map(c=>(
                <tr key={c.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,fontWeight:600}}>{c.nome}</td>
                  <td style={{...S.td}}><span style={{background:"#3B82F622",color:"#3B82F6",padding:"2px 8px",borderRadius:10,fontSize:11}}>{c.tipo}</span></td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.doc}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.email}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.cidade}-{c.uf}</td>
                  <td style={{...S.td,color:"#10B981",fontWeight:700}}>R$ {c.limite}</td>
                  <td style={S.td}><Badge s={c.ativo?"ativo":"suspenso"}/></td>
                  <td style={S.td}><div style={{display:"flex",gap:5}}>
                    <Btn sm c="#8B5CF6" onClick={()=>{setModal("cli");setForm({...c});}} ch="✏️"/>
                    <Btn sm out c="#EF4444" onClick={()=>atualizarItem("clientes",c.id,{ativo:!c.ativo})} ch={c.ativo?"Inativar":"Ativar"}/>
                  </div></td>
                </tr>
              ))}
              empty="Nenhum cliente cadastrado"
            />}/>
          </div>
        )}

        {/* FORNECEDORES */}
        {aba==="fornecedores"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Fornecedores</h1><div style={{color:"#64748B",fontSize:12}}>{fornecedores.length} cadastrados</div></div>
              <Btn onClick={()=>{setModal("forn");setForm({nome:"",tipo:"PJ",doc:"",email:"",tel:"",cidade:"",uf:"SP",cat:"",obs:""});}} ch="+ Novo"/>
            </div>
            {modal==="forn"&&<Modal title="Novo fornecedor" onClose={()=>setModal(null)} ch={<>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <Campo label="Nome/Razão Social" value={form.nome} onChange={v=>f("nome",v)} cols={2}/>
                <Campo label="Tipo" value={form.tipo} onChange={v=>f("tipo",v)} options={["PF","PJ"]}/>
                <Campo label="CPF/CNPJ" value={form.doc} onChange={v=>f("doc",v)}/>
                <Campo label="Email" value={form.email} onChange={v=>f("email",v)}/>
                <Campo label="Telefone" value={form.tel} onChange={v=>f("tel",v)}/>
                <Campo label="Cidade" value={form.cidade} onChange={v=>f("cidade",v)}/>
                <Campo label="UF" value={form.uf} onChange={v=>f("uf",v)}/>
                <Campo label="Categoria" value={form.cat} onChange={v=>f("cat",v)}/>
                <Campo label="Observações" value={form.obs} onChange={v=>f("obs",v)} cols={2}/>
              </div>
              <Btn onClick={()=>salvarCol("fornecedores",form)} c="#10B981" ch="✓ Salvar"/>
            </>}/>}
            <Card ch={<Tabela
              cols={["Nome","Tipo","Doc","Email","Cidade","Categoria",""]}
              rows={fornecedores.map(c=>(
                <tr key={c.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,fontWeight:600}}>{c.nome}</td>
                  <td style={S.td}><span style={{background:"#8B5CF622",color:"#8B5CF6",padding:"2px 8px",borderRadius:10,fontSize:11}}>{c.tipo}</span></td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.doc}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.email}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.cidade}-{c.uf}</td>
                  <td style={{...S.td,color:"#F59E0B",fontSize:12}}>{c.cat}</td>
                  <td style={S.td}><Btn sm out c="#EF4444" onClick={()=>deletarItem("fornecedores",c.id)} ch="Excluir"/></td>
                </tr>
              ))}
              empty="Nenhum fornecedor cadastrado"
            />}/>
          </div>
        )}

        {/* CONTAS A RECEBER */}
        {aba==="cr"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Contas a Receber</h1><div style={{color:"#64748B",fontSize:12}}>{cr.length} lançamentos</div></div>
              <Btn onClick={()=>{setModal("cr");setForm({cli:"",svc:"",val:"",venc:"",tipo:"pix",av:"",st:"pendente"});}} ch="+ Novo"/>
            </div>
            {modal==="cr"&&<Modal title="Nova conta a receber" onClose={()=>setModal(null)} ch={<>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <Campo label="Cliente" value={form.cli} onChange={v=>f("cli",v)} cols={2}/>
                <Campo label="Descrição/Serviço" value={form.svc} onChange={v=>f("svc",v)} cols={2}/>
                <Campo label="Valor (R$)" value={form.val} onChange={v=>f("val",v)} type="number"/>
                <Campo label="Vencimento" value={form.venc} onChange={v=>f("venc",v)} type="date"/>
                <Campo label="Forma" value={form.tipo} onChange={v=>f("tipo",v)} options={["pix","boleto","cartao","ted","dinheiro"]}/>
                <Campo label="Status" value={form.st} onChange={v=>f("st",v)} options={["pendente","recebido","vencido"]}/>
              </div>
              <Btn onClick={()=>salvarCol("cr",{...form,val:parseFloat(form.val||0)})} c="#10B981" ch="✓ Salvar"/>
            </>}/>}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:18}}>
              <Metric label="Pendente" valor={fmt(cr.filter(x=>x.st==="pendente").reduce((a,x)=>a+(x.val||0),0))} sub={cr.filter(x=>x.st==="pendente").length+" títulos"} c="#10B981" icon="📥"/>
              <Metric label="Vencidos" valor={fmt(cr.filter(x=>x.st==="vencido").reduce((a,x)=>a+(x.val||0),0))} c="#EF4444" icon="⏰"/>
              <Metric label="Recebidos" valor={fmt(cr.filter(x=>x.st==="recebido").reduce((a,x)=>a+(x.val||0),0))} c="#3B82F6" icon="✅"/>
            </div>
            <Card ch={<Tabela
              cols={["Cliente","Serviço","Valor","Vencimento","Forma","Status",""]}
              rows={cr.map(r=>(
                <tr key={r.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,fontWeight:600}}>{r.cli}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{r.svc}</td>
                  <td style={{...S.td,fontWeight:700,color:r.st==="vencido"?"#EF4444":"#10B981"}}>{fmt(r.val)}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{r.venc}</td>
                  <td style={{...S.td,fontSize:12}}><span style={{background:"#3B82F622",color:"#3B82F6",padding:"2px 8px",borderRadius:10,fontSize:11}}>{r.tipo}</span></td>
                  <td style={S.td}><Badge s={r.st}/></td>
                  <td style={S.td}><div style={{display:"flex",gap:5}}>
                    {r.st!=="recebido"&&<Btn sm c="#10B981" onClick={()=>atualizarItem("cr",r.id,{st:"recebido"})} ch="✓ Recebido"/>}
                    <Btn sm out c="#EF4444" onClick={()=>deletarItem("cr",r.id)} ch="🗑"/>
                  </div></td>
                </tr>
              ))}
              empty="Nenhuma conta a receber"
            />}/>
          </div>
        )}

        {/* CONTAS A PAGAR */}
        {aba==="cp"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Contas a Pagar</h1><div style={{color:"#64748B",fontSize:12}}>{cp.length} lançamentos</div></div>
              <Btn onClick={()=>{setModal("cp");setForm({forn:"",cat:"",val:"",venc:"",st:"agendado",aprov:false});}} ch="+ Novo"/>
            </div>
            {modal==="cp"&&<Modal title="Nova conta a pagar" onClose={()=>setModal(null)} ch={<>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <Campo label="Fornecedor" value={form.forn} onChange={v=>f("forn",v)} cols={2}/>
                <Campo label="Valor (R$)" value={form.val} onChange={v=>f("val",v)} type="number"/>
                <Campo label="Vencimento" value={form.venc} onChange={v=>f("venc",v)} type="date"/>
                <Campo label="Categoria" value={form.cat} onChange={v=>f("cat",v)} options={["Pessoal","Utilidades","Materia-Prima","Serviços","Impostos","Outros"]}/>
                <Campo label="Status" value={form.st} onChange={v=>f("st",v)} options={["agendado","pendente","pago"]}/>
              </div>
              <Btn onClick={()=>salvarCol("cp",{...form,val:parseFloat(form.val||0)})} c="#10B981" ch="✓ Salvar"/>
            </>}/>}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:18}}>
              <Metric label="Pendente" valor={fmt(cp.filter(x=>x.st!=="pago").reduce((a,x)=>a+(x.val||0),0))} sub={cp.filter(x=>x.st!=="pago").length+" títulos"} c="#EF4444" icon="📤"/>
              <Metric label="Pago" valor={fmt(cp.filter(x=>x.st==="pago").reduce((a,x)=>a+(x.val||0),0))} c="#10B981" icon="✅"/>
              <Metric label="Total do mês" valor={fmt(cp.reduce((a,x)=>a+(x.val||0),0))} c="#8B5CF6" icon="📊"/>
            </div>
            <Card ch={<Tabela
              cols={["Fornecedor","Categoria","Valor","Vencimento","Status",""]}
              rows={cp.map(p=>(
                <tr key={p.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,fontWeight:600}}>{p.forn}</td>
                  <td style={{...S.td,fontSize:12}}><span style={{background:"#F59E0B22",color:"#F59E0B",padding:"2px 8px",borderRadius:10,fontSize:11}}>{p.cat}</span></td>
                  <td style={{...S.td,fontWeight:700,color:"#EF4444"}}>{fmt(p.val)}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{p.venc}</td>
                  <td style={S.td}><Badge s={p.st}/></td>
                  <td style={S.td}><div style={{display:"flex",gap:5}}>
                    {p.st!=="pago"&&<Btn sm c="#10B981" onClick={()=>atualizarItem("cp",p.id,{st:"pago"})} ch="✓ Pagar"/>}
                    <Btn sm out c="#EF4444" onClick={()=>deletarItem("cp",p.id)} ch="🗑"/>
                  </div></td>
                </tr>
              ))}
              empty="Nenhuma conta a pagar"
            />}/>
          </div>
        )}

        {/* PRODUTOS */}
        {aba==="prod"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Produtos/Serviços</h1><div style={{color:"#64748B",fontSize:12}}>{prod.length} cadastrados</div></div>
              <Btn onClick={()=>{setModal("prod");setForm({n:"",tp:"Produto",cat:"",p:"",custo:"",un:"UN",barcode:"",ncm:"",est:0});}} ch="+ Novo"/>
            </div>
            {modal==="prod"&&<Modal title="Novo produto/serviço" onClose={()=>setModal(null)} ch={<>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <Campo label="Nome" value={form.n} onChange={v=>f("n",v)} cols={2}/>
                <Campo label="Tipo" value={form.tp} onChange={v=>f("tp",v)} options={["Produto","Serviço"]}/>
                <Campo label="Categoria" value={form.cat} onChange={v=>f("cat",v)}/>
                <Campo label="Preço de venda (R$)" value={form.p} onChange={v=>f("p",v)} type="number"/>
                <Campo label="Custo (R$)" value={form.custo} onChange={v=>f("custo",v)} type="number"/>
                <Campo label="Unidade" value={form.un} onChange={v=>f("un",v)} options={["UN","HR","MT","KG","LT","CX"]}/>
                <Campo label="Código de barras" value={form.barcode} onChange={v=>f("barcode",v)}/>
                <Campo label="NCM" value={form.ncm} onChange={v=>f("ncm",v)}/>
              </div>
              <Btn onClick={()=>salvarCol("prod",{...form,p:parseFloat(form.p||0),custo:parseFloat(form.custo||0)})} c="#10B981" ch="✓ Salvar"/>
            </>}/>}
            <Card ch={<Tabela
              cols={["Nome","Tipo","Categoria","Preço","Custo","Unidade","Margem",""]}
              rows={prod.map(p=>(
                <tr key={p.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,fontWeight:600}}>{p.n}</td>
                  <td style={S.td}><span style={{background:"#8B5CF622",color:"#8B5CF6",padding:"2px 8px",borderRadius:10,fontSize:11}}>{p.tp}</span></td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{p.cat}</td>
                  <td style={{...S.td,fontWeight:700,color:"#10B981"}}>{fmt(p.p)}</td>
                  <td style={{...S.td,color:"#94A3B8"}}>{fmt(p.custo)}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{p.un}</td>
                  <td style={{...S.td,fontWeight:700,color:"#F59E0B"}}>{p.custo>0?((p.p-p.custo)/p.p*100).toFixed(1)+"%" :"—"}</td>
                  <td style={S.td}><Btn sm out c="#EF4444" onClick={()=>deletarItem("prod",p.id)} ch="🗑"/></td>
                </tr>
              ))}
              empty="Nenhum produto cadastrado"
            />}/>
          </div>
        )}

        {/* ESTOQUE */}
        {aba==="estoque"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Estoque</h1><div style={{color:"#64748B",fontSize:12}}>{estoque.length} movimentações</div></div>
              <Btn onClick={()=>{setModal("est");setForm({prodNome:prod[0]?.n||"",tipo:"entrada",qtd:"",custo:"",resp:"",obs:""});}} ch="+ Movimentação"/>
            </div>
            {modal==="est"&&<Modal title="Movimentação de estoque" onClose={()=>setModal(null)} ch={<>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <Campo label="Produto" value={form.prodNome} onChange={v=>f("prodNome",v)} options={prod.filter(p=>p.tp==="Produto").map(p=>p.n)} cols={2}/>
                <Campo label="Tipo" value={form.tipo} onChange={v=>f("tipo",v)} options={["entrada","saida"]}/>
                <Campo label="Quantidade" value={form.qtd} onChange={v=>f("qtd",v)} type="number"/>
                <Campo label="Custo unit. (R$)" value={form.custo} onChange={v=>f("custo",v)} type="number"/>
                <Campo label="Responsável" value={form.resp} onChange={v=>f("resp",v)}/>
                <Campo label="Observações" value={form.obs} onChange={v=>f("obs",v)} cols={2}/>
              </div>
              <Btn onClick={()=>salvarCol("estoque",{...form,qtd:parseInt(form.qtd||0),custo:parseFloat(form.custo||0),data:new Date().toLocaleDateString("pt-BR")})} c="#10B981" ch="✓ Registrar"/>
            </>}/>}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:18}}>
              <Metric label="Entradas" valor={fmtN(estoque.filter(e=>e.tipo==="entrada").reduce((a,e)=>a+(e.qtd||0),0))} sub="total itens" c="#10B981" icon="📥"/>
              <Metric label="Saídas" valor={fmtN(estoque.filter(e=>e.tipo==="saida").reduce((a,e)=>a+(e.qtd||0),0))} sub="total itens" c="#EF4444" icon="📤"/>
              <Metric label="Valor total" valor={fmt(estoque.filter(e=>e.tipo==="entrada").reduce((a,e)=>a+(e.qtd||0)*(e.custo||0),0))} c="#8B5CF6" icon="💎"/>
            </div>
            <Card ch={<Tabela
              cols={["Data","Produto","Tipo","Qtd","Custo unit.","Responsável","Obs"]}
              rows={estoque.map(e=>(
                <tr key={e.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{e.data}</td>
                  <td style={{...S.td,fontWeight:600}}>{e.prodNome}</td>
                  <td style={S.td}><Badge s={e.tipo}/></td>
                  <td style={{...S.td,fontWeight:700,color:e.tipo==="entrada"?"#10B981":"#EF4444"}}>{e.tipo==="entrada"?"+":"-"}{e.qtd}</td>
                  <td style={{...S.td,color:"#94A3B8"}}>{fmt(e.custo)}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{e.resp}</td>
                  <td style={{...S.td,color:"#64748B",fontSize:12}}>{e.obs}</td>
                </tr>
              ))}
              empty="Nenhuma movimentação registrada"
            />}/>
          </div>
        )}

        {/* FROTA */}
        {aba==="frota"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Frota</h1><div style={{color:"#64748B",fontSize:12}}>{frota.length} veículos · {veicDisp} disponíveis</div></div>
              <Btn onClick={()=>{setModal("frota");setForm({placa:"",modelo:"",ano:"",cor:"",km:"",motorista:"",st:"disponivel",venc_seguro:"",venc_ipva:""});}} ch="+ Veículo"/>
            </div>
            {modal==="frota"&&<Modal title="Novo veículo" onClose={()=>setModal(null)} ch={<>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <Campo label="Placa" value={form.placa} onChange={v=>f("placa",v)}/>
                <Campo label="Modelo" value={form.modelo} onChange={v=>f("modelo",v)}/>
                <Campo label="Ano" value={form.ano} onChange={v=>f("ano",v)} type="number"/>
                <Campo label="Cor" value={form.cor} onChange={v=>f("cor",v)}/>
                <Campo label="KM atual" value={form.km} onChange={v=>f("km",v)} type="number"/>
                <Campo label="Motorista" value={form.motorista} onChange={v=>f("motorista",v)}/>
                <Campo label="Status" value={form.st} onChange={v=>f("st",v)} options={["disponivel","em_uso","manutencao"]}/>
                <Campo label="Venc. Seguro" value={form.venc_seguro} onChange={v=>f("venc_seguro",v)}/>
                <Campo label="Venc. IPVA" value={form.venc_ipva} onChange={v=>f("venc_ipva",v)}/>
              </div>
              <Btn onClick={()=>salvarCol("frota",{...form,km:parseInt(form.km||0)})} c="#10B981" ch="✓ Salvar"/>
            </>}/>}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:18}}>
              <Metric label="Disponíveis" valor={fmtN(veicDisp)} c="#10B981" icon="🚗"/>
              <Metric label="Em uso" valor={fmtN(frota.filter(v=>v.st==="em_uso").length)} c="#3B82F6" icon="🔑"/>
              <Metric label="Manutenção" valor={fmtN(frota.filter(v=>v.st==="manutencao").length)} c="#F59E0B" icon="🔧"/>
            </div>
            <Card ch={<Tabela
              cols={["Placa","Modelo","Ano","KM","Motorista","Seguro","IPVA","Status",""]}
              rows={frota.map(v=>(
                <tr key={v.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,fontWeight:700,color:"#3B82F6"}}>{v.placa}</td>
                  <td style={{...S.td,fontWeight:600}}>{v.modelo}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{v.ano}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{fmtN(v.km)} km</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{v.motorista||"—"}</td>
                  <td style={{...S.td,fontSize:12}}>{v.venc_seguro}</td>
                  <td style={{...S.td,fontSize:12}}>{v.venc_ipva}</td>
                  <td style={S.td}><Badge s={v.st}/></td>
                  <td style={S.td}><select value={v.st} onChange={e=>atualizarItem("frota",v.id,{st:e.target.value})} style={{background:"#0F172A",border:"1px solid #334155",borderRadius:6,padding:"4px 8px",color:"#F1F5F9",fontSize:12}}>
                    <option value="disponivel">Disponível</option>
                    <option value="em_uso">Em uso</option>
                    <option value="manutencao">Manutenção</option>
                  </select></td>
                </tr>
              ))}
              empty="Nenhum veículo cadastrado"
            />}/>
          </div>
        )}

        {/* TRIBUTOS */}
        {aba==="tributos"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Tributos</h1><div style={{color:"#64748B",fontSize:12}}>{tr.length} lançamentos</div></div>
              <Btn onClick={()=>{setModal("tr");setForm({n:"",comp:"",venc:"",val:"",st:"pendente",tp:"Federal"});}} ch="+ Novo"/>
            </div>
            {modal==="tr"&&<Modal title="Novo tributo" onClose={()=>setModal(null)} ch={<>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <Campo label="Tributo" value={form.n} onChange={v=>f("n",v)} options={["IRPJ/CSLL","PIS/COFINS","ICMS","ISS","FGTS","INSS","Simples Nacional","Outros"]}/>
                <Campo label="Competência" value={form.comp} onChange={v=>f("comp",v)}/>
                <Campo label="Vencimento" value={form.venc} onChange={v=>f("venc",v)} type="date"/>
                <Campo label="Valor (R$)" value={form.val} onChange={v=>f("val",v)} type="number"/>
                <Campo label="Tipo" value={form.tp} onChange={v=>f("tp",v)} options={["Federal","Estadual","Municipal"]}/>
                <Campo label="Status" value={form.st} onChange={v=>f("st",v)} options={["pendente","agendado","pago"]}/>
              </div>
              <Btn onClick={()=>salvarCol("tr",{...form,val:parseFloat(form.val||0)})} c="#10B981" ch="✓ Salvar"/>
            </>}/>}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:18}}>
              <Metric label="A pagar" valor={fmt(tr.filter(x=>x.st!=="pago").reduce((a,x)=>a+(x.val||0),0))} sub={tr.filter(x=>x.st!=="pago").length+" tributos"} c="#EF4444" icon="🧾"/>
              <Metric label="Pago" valor={fmt(tr.filter(x=>x.st==="pago").reduce((a,x)=>a+(x.val||0),0))} c="#10B981" icon="✅"/>
              <Metric label="Total" valor={fmt(tr.reduce((a,x)=>a+(x.val||0),0))} c="#8B5CF6" icon="📊"/>
            </div>
            <Card ch={<Tabela
              cols={["Tributo","Competência","Vencimento","Valor","Tipo","Status",""]}
              rows={tr.map(t=>(
                <tr key={t.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,fontWeight:600}}>{t.n}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{t.comp}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{t.venc}</td>
                  <td style={{...S.td,fontWeight:700,color:"#EF4444"}}>{fmt(t.val)}</td>
                  <td style={S.td}><span style={{background:"#3B82F622",color:"#3B82F6",padding:"2px 8px",borderRadius:10,fontSize:11}}>{t.tp}</span></td>
                  <td style={S.td}><Badge s={t.st}/></td>
                  <td style={S.td}>{t.st!=="pago"&&<Btn sm c="#10B981" onClick={()=>atualizarItem("tr",t.id,{st:"pago"})} ch="✓ Pago"/>}</td>
                </tr>
              ))}
              empty="Nenhum tributo cadastrado"
            />}/>
          </div>
        )}

        {/* BANCOS */}
        {aba==="bancos"&&(
          <BancosPanel empAtual={empAtual} bancos={bancos} dados={dados} modal={modal} setModal={setModal} form={form} setForm={setForm} f={f} salvarCol={salvarCol} atualizarItem={atualizarItem} carregarDados={carregarDados}/>
        )}

        {/* RELATÓRIOS */}

        {aba==="faturas"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Faturas</h1><div style={{color:"#64748B",fontSize:12}}>{faturas.length.toLocaleString("pt-BR")} faturas importadas do MK Solutions</div></div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:18}}>
              {[["Pendentes",faturas.filter(f=>f.status==="pendente").length,"#F59E0B","⏳"],["Pagas",faturas.filter(f=>f.status==="pago").length,"#10B981","✅"],["Vencidas",faturas.filter(f=>f.status==="vencido").length,"#EF4444","⏰"],["Total",faturas.length,"#3B82F6","📄"]].map(([l,v,c,ic])=>(
                <Card key={l} ch={<div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}><div><div style={{color:"#94A3B8",fontSize:12,marginBottom:4}}>{l}</div><div style={{color:"#F1F5F9",fontSize:22,fontWeight:700}}>{v.toLocaleString("pt-BR")}</div></div><div style={{width:36,height:36,borderRadius:9,background:c+"22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:17}}>{ic}</div></div>}/>
              ))}
            </div>
            <div style={{display:"flex",gap:8,marginBottom:14}}>
              {["todos","pendente","pago","vencido"].map(s=>(
                <button key={s} onClick={()=>setBusca(s==="todos"?"":s)} style={{padding:"6px 14px",borderRadius:7,border:"1px solid #334155",background:busca===s||(!busca&&s==="todos")?"#3B82F6":"transparent",color:busca===s||(!busca&&s==="todos")?"#fff":"#94A3B8",fontSize:12,cursor:"pointer",textTransform:"capitalize"}}>{s}</button>
              ))}
              <input value={busca.startsWith("p")||busca.startsWith("v")||busca.startsWith("t")?"":(busca||"")} onChange={e=>setBusca(e.target.value)} placeholder="🔍 Buscar cliente..." style={{...S.inp,width:220,marginLeft:"auto"}}/>
            </div>
            <Card ch={<Tabela
              cols={["Nº Fatura","Cliente","Descrição","Valor","Vencimento","Pago em","Status"]}
              rows={(busca&&!["pendente","pago","vencido"].includes(busca)
                ? faturas.filter(f=>f.cliente?.toLowerCase().includes(busca.toLowerCase()))
                : busca?faturas.filter(f=>f.status===busca):faturas
              ).slice(0,200).map(f=>(
                <tr key={f.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,color:"#3B82F6",fontSize:11,fontFamily:"monospace"}}>{f.id}</td>
                  <td style={{...S.td,fontWeight:600,fontSize:12}}>{f.cliente}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{f.desc}</td>
                  <td style={{...S.td,fontWeight:700,color:f.status==="vencido"?"#EF4444":f.status==="pago"?"#10B981":"#F1F5F9"}}>{new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(f.valor)}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{f.venc}</td>
                  <td style={{...S.td,color:"#10B981",fontSize:12}}>{f.pago_em||"—"}</td>
                  <td style={S.td}><span style={{background:({"pago":"#10B981","pendente":"#F59E0B","vencido":"#EF4444"}[f.status]||"#6B7280")+"22",color:{"pago":"#10B981","pendente":"#F59E0B","vencido":"#EF4444"}[f.status]||"#6B7280",padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:700,textTransform:"capitalize"}}>{f.status}</span></td>
                </tr>
              ))}
              empty="Nenhuma fatura encontrada"
            />}/>
            <div style={{textAlign:"center",marginTop:12,color:"#475569",fontSize:12}}>Exibindo até 200 registros por vez — use a busca para filtrar</div>
          </div>
        )}

        {aba==="conexoes"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Conexões Técnicas</h1><div style={{color:"#64748B",fontSize:12}}>{conexoes.length} conexões PPPoE importadas do MK Solutions</div></div>
              <input value={busca} onChange={e=>setBusca(e.target.value)} placeholder="🔍 Buscar cliente, login, IP..." style={{...S.inp,width:260}}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:18}}>
              {[["Total conexões",conexoes.length,"#3B82F6","🔌"],["Bloqueadas",conexoes.filter(c=>c.bloqueado).length,"#EF4444","🚫"],["PPPoE",conexoes.filter(c=>c.tipo==="pppoe"||c.tipo==="PPPoE").length,"#10B981","📡"],["Com IP",conexoes.filter(c=>c.ip&&c.ip.length>3).length,"#8B5CF6","🌐"]].map(([l,v,c,ic])=>(
                <Card key={l} ch={<div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}><div><div style={{color:"#94A3B8",fontSize:12,marginBottom:4}}>{l}</div><div style={{color:"#F1F5F9",fontSize:22,fontWeight:700}}>{v.toLocaleString("pt-BR")}</div></div><div style={{width:36,height:36,borderRadius:9,background:c+"22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:17}}>{ic}</div></div>}/>
              ))}
            </div>
            <Card ch={<Tabela
              cols={["Cliente","Login PPPoE","Senha","MAC Address","IP","Tipo","Plano","Velocidade","Status"]}
              rows={conexoes.filter(c=>!busca||c.cliente?.toLowerCase().includes(busca.toLowerCase())||c.username?.toLowerCase().includes(busca.toLowerCase())||c.ip?.includes(busca)).slice(0,200).map(c=>(
                <tr key={c.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,fontWeight:600,fontSize:12}}>{c.cliente}</td>
                  <td style={{...S.td,color:"#3B82F6",fontFamily:"monospace",fontSize:12}}>{c.username}</td>
                  <td style={{...S.td,color:"#64748B",fontSize:11,fontFamily:"monospace"}}>{c.password}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:11,fontFamily:"monospace"}}>{c.mac||"—"}</td>
                  <td style={{...S.td,color:"#10B981",fontSize:11,fontFamily:"monospace"}}>{c.ip||"—"}</td>
                  <td style={{...S.td,fontSize:11}}><span style={{background:"#3B82F622",color:"#3B82F6",padding:"2px 8px",borderRadius:10,fontSize:11}}>{c.tipo}</span></td>
                  <td style={{...S.td,color:"#8B5CF6",fontSize:12}}>{c.plano}</td>
                  <td style={{...S.td,fontSize:12}}><span style={{color:"#10B981"}}>{c.vel_down}</span><span style={{color:"#64748B"}}> ↓ </span><span style={{color:"#F59E0B"}}>{c.vel_up}</span><span style={{color:"#64748B"}}> ↑</span></td>
                  <td style={S.td}><span style={{background:c.bloqueado?"#EF444422":"#10B98122",color:c.bloqueado?"#EF4444":"#10B981",padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{c.bloqueado?"Bloqueado":"Ativo"}</span></td>
                </tr>
              ))}
              empty="Nenhuma conexão encontrada"
            />}/>
            <div style={{textAlign:"center",marginTop:12,color:"#475569",fontSize:12}}>Exibindo até 200 por vez — use a busca para filtrar</div>
          </div>
        )}

        {aba==="planos_det"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Planos Detalhados</h1><div style={{color:"#64748B",fontSize:12}}>{planos_det.length} planos importados do MK Solutions</div></div>
              <input value={busca} onChange={e=>setBusca(e.target.value)} placeholder="🔍 Buscar plano..." style={{...S.inp,width:220}}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:18}}>
              {[["Total planos",planos_det.length,"#3B82F6","📡"],["Ativos",planos_det.filter(p=>p.ativo).length,"#10B981","✅"],["Inativos",planos_det.filter(p=>!p.ativo).length,"#EF4444","🚫"],["Valor médio",planos_det.filter(p=>p.ativo).length>0?new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(planos_det.filter(p=>p.ativo).reduce((a,p)=>a+p.mensalidade,0)/planos_det.filter(p=>p.ativo).length):"R$ 0","#8B5CF6","💰"]].map(([l,v,c,ic])=>(
                <Card key={l} ch={<div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}><div><div style={{color:"#94A3B8",fontSize:12,marginBottom:4}}>{l}</div><div style={{color:"#F1F5F9",fontSize:typeof v==="number"?22:16,fontWeight:700}}>{typeof v==="number"?v.toLocaleString("pt-BR"):v}</div></div><div style={{width:36,height:36,borderRadius:9,background:c+"22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:17}}>{ic}</div></div>}/>
              ))}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16}}>
              {planos_det.filter(p=>!busca||p.nome?.toLowerCase().includes(busca.toLowerCase())).map(p=>(
                <Card key={p.id} style={{borderColor:p.ativo?"#334155":"#1E293B",opacity:p.ativo?1:0.6}} ch={<>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                    <div>
                      <div style={{fontWeight:700,fontSize:14,marginBottom:4}}>{p.nome}</div>
                      <div style={{fontSize:10,color:"#64748B",fontFamily:"monospace"}}>{p.id}</div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div style={{fontSize:20,fontWeight:800,color:"#10B981"}}>{new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(p.mensalidade)}</div>
                      <div style={{fontSize:11,color:"#64748B"}}>mensalidade</div>
                    </div>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
                    {[["⬇️ Download",p.vel_down],["⬆️ Upload",p.vel_up],["⬇️ Burst Down",p.burst_down||"—"],["⬆️ Burst Up",p.burst_up||"—"],["⏱️ Burst Time",p.burst_time||"—"],["📅 Fidelidade",p.meses_fidelidade?p.meses_fidelidade+" meses":"—"]].map(([l,v])=>(
                      <div key={l} style={{background:"#0F172A",borderRadius:7,padding:"7px 10px"}}>
                        <div style={{color:"#64748B",fontSize:10}}>{l}</div>
                        <div style={{color:"#F1F5F9",fontSize:13,fontWeight:600,fontFamily:"monospace"}}>{v}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{background:p.ativo?"#10B98122":"#EF444422",color:p.ativo?"#10B981":"#EF4444",padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{p.ativo?"Ativo":"Inativo"}</span>
                    {p.tipo&&<span style={{background:"#3B82F622",color:"#3B82F6",padding:"3px 10px",borderRadius:20,fontSize:11}}>{p.tipo}</span>}
                  </div>
                </>}/>
              ))}
            </div>
          </div>
        )}


        {aba==="relatorios"&&(
          <RelatoriosPanel dados={dados} empAtual={empAtual}/>
        )}

        {/* USUÁRIOS */}
        {aba==="usuarios"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Usuários</h1><div style={{color:"#64748B",fontSize:12}}>{usuarios.length} cadastrados</div></div>
              <Btn onClick={()=>{setModal("usr");setForm({nome:"",email:"",perfil:"Operacional",setor:"",tel:"",st:"ativo"});}} ch="+ Novo usuário"/>
            </div>
            {modal==="usr"&&<Modal title="Novo usuário" onClose={()=>setModal(null)} ch={<>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <Campo label="Nome" value={form.nome} onChange={v=>f("nome",v)} cols={2}/>
                <Campo label="Email" value={form.email} onChange={v=>f("email",v)}/>
                <Campo label="Telefone" value={form.tel} onChange={v=>f("tel",v)}/>
                <Campo label="Perfil" value={form.perfil} onChange={v=>f("perfil",v)} options={["Administrador","Financeiro","Operacional","Técnico","Visualização"]}/>
                <Campo label="Setor" value={form.setor} onChange={v=>f("setor",v)}/>
              </div>
              <Btn onClick={()=>salvarCol("usuarios",form)} c="#10B981" ch="✓ Salvar"/>
            </>}/>}
            <Card ch={<Tabela
              cols={["Nome","Email","Perfil","Setor","Status","Último acesso",""]}
              rows={usuarios.map(u=>(
                <tr key={u.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{...S.td,fontWeight:600}}>{u.nome}</td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{u.email}</td>
                  <td style={S.td}><span style={{background:"#3B82F622",color:"#3B82F6",padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{u.perfil}</span></td>
                  <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{u.setor}</td>
                  <td style={S.td}><Badge s={u.st}/></td>
                  <td style={{...S.td,color:"#64748B",fontSize:12}}>{u.ultimoAcesso||"—"}</td>
                  <td style={S.td}><Btn sm out c="#EF4444" onClick={()=>atualizarItem("usuarios",u.id,{st:u.st==="ativo"?"suspenso":"ativo"})} ch={u.st==="ativo"?"Suspender":"Ativar"}/></td>
                </tr>
              ))}
              empty="Nenhum usuário cadastrado"
            />}/>
          </div>
        )}

        </>}
      </div>
    </div>
  );
}

// ── APP ──────────────────────────────────────────────────────────────────────

// ── BANCOS PANEL — Integração PIX em tempo real ───────────────────────────────
function BancosPanel({empAtual, bancos, dados, modal, setModal, form, setForm, f, salvarCol, atualizarItem, carregarDados}) {
  const [abaB, setAbaB] = useState("contas");
  const [testando, setTestando] = useState(false);
  const [msgTeste, setMsgTeste] = useState("");
  const [configurando, setConfigurando] = useState(null);
  const [formC6, setFormC6] = useState({client_id:"",client_secret:"",cert:"",key_pem:"",chave_pix:""});
  const extrato = dados?.extrato_pix || [];
  const webhookUrl = "https://erp.nextnetworking.com.br/api/c6/webhook/" + (empAtual?.id||"");

  const testarConexao = async (bancoId) => {
    setTestando(true); setMsgTeste("");
    try {
      const r = await fetch("/api/c6/" + (empAtual?.id||"") + "/auth/test", {method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({bancoId})});
      const d = await r.json();
      setMsgTeste(d.ok ? "✅ Conexão OK! Token obtido com sucesso." : "❌ Erro: " + (d.error||"Falha na autenticação"));
    } catch(e) { setMsgTeste("❌ Erro de rede: " + e.message); }
    setTestando(false);
  };

  const salvarC6 = async () => {
    if (!configurando) return;
    await atualizarItem("bancos", configurando, {
      api_c6_id: formC6.client_id,
      api_c6_secret: formC6.client_secret,
      chave_pix: formC6.chave_pix,
      c6_configurado: true,
    });
    setConfigurando(null);
    setMsgTeste("✅ Credenciais salvas! Clique em Testar Conexão.");
    carregarDados();
  };

  const registrarWebhook = async (bancoId, chave) => {
    try {
      const r = await fetch("/api/c6/" + (empAtual?.id||"") + "/pix/webhook/" + chave, {
        method:"PUT", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({webhookUrl})
      });
      const d = await r.json();
      setMsgTeste(d.error ? "❌ " + d.error : "✅ Webhook registrado no C6 Bank!");
    } catch(e) { setMsgTeste("❌ Erro: " + e.message); }
  };

  const pixRecebidos = extrato.filter(p => p.processado);
  const pixNaoAssociados = extrato.filter(p => !p.processado);

  return (
    <div>
      <div style={{marginBottom:20}}>
        <h1 style={{fontSize:20,fontWeight:800}}>Bancos & Integração PIX</h1>
        <div style={{color:"#64748B",fontSize:12}}>{bancos.length} conta(s) · Recebimento PIX em tempo real</div>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:6,marginBottom:20,background:"#1E293B",padding:4,borderRadius:10,width:"fit-content"}}>
        {[["contas","🏦 Contas"],["pix","⚡ PIX em Tempo Real"],["extrato","📋 Extrato PIX"],["config","⚙️ Configurar API"]].map(([id,lb])=>(
          <button key={id} onClick={()=>setAbaB(id)} style={{padding:"8px 16px",borderRadius:7,border:"none",background:abaB===id?"#3B82F6":"transparent",color:abaB===id?"#fff":"#64748B",fontWeight:600,fontSize:12,cursor:"pointer"}}>{lb}</button>
        ))}
      </div>

      {msgTeste&&<div style={{background:msgTeste.includes("✅")?"#10B98122":"#EF444422",color:msgTeste.includes("✅")?"#10B981":"#EF4444",padding:"10px 16px",borderRadius:8,marginBottom:16,fontSize:13}}>{msgTeste}</div>}

      {/* ABA CONTAS */}
      {abaB==="contas"&&(
        <div>
          {modal==="banco"&&<Card style={{marginBottom:20,borderColor:"#3B82F6",borderWidth:2}} ch={<>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div style={{fontWeight:700,fontSize:15}}>Nova conta bancária</div>
              <Btn sm out c="#EF4444" onClick={()=>setModal(null)} ch="✕"/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
              {[["Banco","banco"],["Agência","ag"],["Conta","cc"],["Titular","titular"],["CPF/CNPJ","cpfcnpj"],["Chave PIX","pix"],["Saldo inicial","saldo"]].map(([l,k])=>(
                <div key={k}><label style={{color:"#94A3B8",fontSize:12,display:"block",marginBottom:4}}>{l}</label>
                  <input value={form[k]||""} onChange={e=>f(k,e.target.value)} type={k==="saldo"?"number":"text"} style={{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"9px 11px",color:"#F1F5F9",fontSize:13,boxSizing:"border-box"}}/></div>
              ))}
              <div><label style={{color:"#94A3B8",fontSize:12,display:"block",marginBottom:4}}>Tipo</label>
                <select value={form.tipo||"Corrente"} onChange={e=>f("tipo",e.target.value)} style={{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"9px 11px",color:"#F1F5F9",fontSize:13}}>
                  {["Corrente","Poupança","Pagamento"].map(o=><option key={o}>{o}</option>)}
                </select></div>
            </div>
            <Btn onClick={()=>salvarCol("bancos",{...form,saldo:parseFloat(form.saldo||0)})} c="#10B981" ch="✓ Salvar"/>
          </>}/>}
          <div style={{display:"flex",justifyContent:"flex-end",marginBottom:14}}>
            <Btn onClick={()=>{setModal("banco");setForm({banco:"",ag:"",cc:"",tipo:"Corrente",titular:"",cpfcnpj:"",pix:"",saldo:"0"});}} ch="+ Nova conta"/>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:16}}>
            {bancos.map(b=>(
              <Card key={b.id} style={{borderColor:b.c6_configurado?"#10B981":"#334155",borderWidth:b.c6_configurado?2:1}} ch={<>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:16,marginBottom:3}}>{b.banco}</div>
                    <div style={{color:"#64748B",fontSize:12}}>Ag {b.ag} · CC {b.cc} · {b.tipo}</div>
                    <div style={{color:"#64748B",fontSize:12,marginTop:2}}>{b.titular} · {b.cpfcnpj}</div>
                    {b.pix&&<div style={{color:"#3B82F6",fontSize:12,marginTop:4}}>🔑 PIX: {b.pix}</div>}
                    {b.c6_configurado&&<div style={{color:"#10B981",fontSize:11,marginTop:4,fontWeight:600}}>✅ API Open Finance conectada</div>}
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{color:"#64748B",fontSize:11}}>Saldo</div>
                    <div style={{fontSize:22,fontWeight:800,color:b.saldo>=0?"#10B981":"#EF4444"}}>{new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(b.saldo||0)}</div>
                  </div>
                </div>
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  {b.banco==="C6 Bank"&&<>
                    <Btn sm c="#8B5CF6" onClick={()=>{setConfigurando(b.id);setFormC6({client_id:b.api_c6_id||"",client_secret:b.api_c6_secret||"",chave_pix:b.chave_pix||b.pix||"",cert:"",key_pem:""});setAbaB("config");}} ch="⚙️ Configurar API"/>
                    {b.c6_configurado&&<>
                      <Btn sm c="#3B82F6" onClick={()=>testarConexao(b.id)} ch={testando?"Testando...":"🔌 Testar"} style={{opacity:testando?0.6:1}}/>
                      <Btn sm c="#10B981" onClick={()=>registrarWebhook(b.id, b.chave_pix||b.pix||"")} ch="📡 Ativar Webhook"/>
                    </>}
                  </>}
                  <Btn sm out c="#EF4444" onClick={()=>{}} ch="🗑 Excluir"/>
                </div>
              </>}/>
            ))}
            {bancos.length===0&&<div style={{color:"#475569",gridColumn:"1/-1",padding:40,textAlign:"center"}}>Nenhuma conta cadastrada</div>}
          </div>
        </div>
      )}

      {/* ABA PIX TEMPO REAL */}
      {abaB==="pix"&&(
        <div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20}}>
            <Card ch={<div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div><div style={{color:"#94A3B8",fontSize:12,marginBottom:4}}>PIX Recebidos hoje</div>
                <div style={{color:"#F1F5F9",fontSize:24,fontWeight:700}}>{extrato.filter(p=>{const h=new Date().toLocaleDateString("pt-BR");return p.recebido_em&&p.recebido_em.startsWith(h);}).length}</div></div>
              <div style={{width:36,height:36,borderRadius:9,background:"#10B98122",display:"flex",alignItems:"center",justifyContent:"center",fontSize:17}}>⚡</div>
            </div>}/>
            <Card ch={<div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div><div style={{color:"#94A3B8",fontSize:12,marginBottom:4}}>Valor recebido hoje</div>
                <div style={{color:"#10B981",fontSize:24,fontWeight:700}}>{new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(extrato.filter(p=>{const h=new Date().toLocaleDateString("pt-BR");return p.recebido_em&&p.recebido_em.startsWith(h);}).reduce((a,p)=>a+(p.valor||0),0))}</div></div>
              <div style={{width:36,height:36,borderRadius:9,background:"#10B98122",display:"flex",alignItems:"center",justifyContent:"center",fontSize:17}}>💰</div>
            </div>}/>
            <Card ch={<div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div><div style={{color:"#94A3B8",fontSize:12,marginBottom:4}}>Não associados</div>
                <div style={{color:pixNaoAssociados.length>0?"#F59E0B":"#10B981",fontSize:24,fontWeight:700}}>{pixNaoAssociados.length}</div>
                <div style={{color:"#64748B",fontSize:11,marginTop:3}}>verificar manualmente</div></div>
              <div style={{width:36,height:36,borderRadius:9,background:"#F59E0B22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:17}}>⚠️</div>
            </div>}/>
          </div>

          <Card ch={<>
            <div style={{fontWeight:700,marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span>PIX Recebidos (tempo real)</span>
              <Btn sm onClick={carregarDados} ch="🔄 Atualizar"/>
            </div>
            {extrato.length===0&&(
              <div style={{textAlign:"center",padding:40,color:"#475569"}}>
                <div style={{fontSize:32,marginBottom:12}}>⚡</div>
                <div style={{fontWeight:600,marginBottom:8}}>Aguardando PIX...</div>
                <div style={{fontSize:13,maxWidth:400,margin:"0 auto",lineHeight:1.6}}>Configure a API do C6 Bank na aba <strong style={{color:"#3B82F6"}}>Configurar API</strong> e registre o webhook para receber notificações em tempo real.</div>
              </div>
            )}
            {extrato.map(p=>(
              <div key={p.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 0",borderBottom:"1px solid #1E293B"}}>
                <div style={{display:"flex",gap:12,alignItems:"center"}}>
                  <div style={{width:36,height:36,borderRadius:9,background:p.processado?"#10B98122":"#F59E0B22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>{p.processado?"✅":"⏳"}</div>
                  <div>
                    <div style={{fontWeight:600,fontSize:13}}>{p.pagador}</div>
                    <div style={{color:"#64748B",fontSize:11}}>{p.cpf_cnpj&&p.cpf_cnpj+" · "}{p.recebido_em}</div>
                    {p.infoPagador&&<div style={{color:"#8B5CF6",fontSize:11}}>"{p.infoPagador}"</div>}
                    {p.cliente&&<div style={{color:"#10B981",fontSize:11}}>→ CR: {p.cliente}</div>}
                  </div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontWeight:800,fontSize:16,color:"#10B981"}}>+{new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(p.valor)}</div>
                  <div style={{fontSize:11,color:p.processado?"#10B981":"#F59E0B"}}>{p.processado?"Associado ao CR":"Não associado"}</div>
                </div>
              </div>
            ))}
          </>}/>
        </div>
      )}

      {/* ABA EXTRATO */}
      {abaB==="extrato"&&(
        <Card ch={<>
          <div style={{fontWeight:700,marginBottom:14,display:"flex",justifyContent:"space-between"}}>
            <span>Extrato PIX Completo ({extrato.length} transações)</span>
            <Btn sm onClick={carregarDados} ch="🔄 Atualizar"/>
          </div>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr style={{borderBottom:"1px solid #334155"}}>
              {["Data/Hora","Pagador","CPF/CNPJ","Valor","Status","Cliente/CR"].map(h=><th key={h} style={{textAlign:"left",padding:"7px 10px",color:"#64748B",fontSize:11,fontWeight:600}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {extrato.length===0&&<tr><td colSpan={6} style={{padding:32,textAlign:"center",color:"#475569"}}>Nenhuma transação PIX registrada</td></tr>}
              {extrato.map(p=>(
                <tr key={p.id} style={{borderBottom:"1px solid #1E293B"}}>
                  <td style={{padding:"10px",fontSize:12,color:"#94A3B8"}}>{p.recebido_em}</td>
                  <td style={{padding:"10px",fontWeight:600,fontSize:13}}>{p.pagador}</td>
                  <td style={{padding:"10px",fontSize:12,color:"#94A3B8"}}>{p.cpf_cnpj}</td>
                  <td style={{padding:"10px",fontWeight:700,color:"#10B981"}}>{new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(p.valor)}</td>
                  <td style={{padding:"10px"}}><span style={{background:p.processado?"#10B98122":"#F59E0B22",color:p.processado?"#10B981":"#F59E0B",padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{p.processado?"Processado":"Pendente"}</span></td>
                  <td style={{padding:"10px",fontSize:12,color:p.cliente?"#10B981":"#64748B"}}>{p.cliente||"—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>}/>
      )}

      {/* ABA CONFIG */}
      {abaB==="config"&&(
        <div>
          <Card style={{marginBottom:16,borderColor:"#F59E0B22",background:"#F59E0B11"}} ch={<>
            <div style={{fontWeight:700,marginBottom:8,color:"#F59E0B"}}>📋 Como configurar a integração C6 Bank</div>
            <div style={{color:"#94A3B8",fontSize:13,lineHeight:1.7}}>
              <div>1. Acesse o app C6 Bank → <strong>Configurações → Conta Digital → API Open Finance</strong></div>
              <div>2. Gere o <strong>Client ID</strong> e <strong>Client Secret</strong></div>
              <div>3. Baixe o <strong>certificado mTLS</strong> (.pem) — necessário para comunicação segura</div>
              <div>4. Cole as credenciais abaixo e clique em <strong>Salvar</strong></div>
              <div>5. Clique em <strong>Testar Conexão</strong> para validar</div>
              <div>6. Clique em <strong>Ativar Webhook</strong> para o C6 notificar esta URL quando receber um PIX</div>
            </div>
            <div style={{marginTop:12,padding:"10px 14px",background:"#0F172A",borderRadius:8,fontFamily:"monospace",fontSize:12,color:"#10B981",wordBreak:"break-all"}}>
              🔗 URL do webhook: {webhookUrl}
            </div>
          </>}/>

          <Card ch={<>
            <div style={{fontWeight:700,marginBottom:16}}>Credenciais API C6 Bank</div>
            <div style={{marginBottom:14}}>
              <label style={{color:"#94A3B8",fontSize:12,display:"block",marginBottom:4}}>Conta bancária</label>
              <select value={configurando||""} onChange={e=>setConfigurando(e.target.value)} style={{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"9px 11px",color:"#F1F5F9",fontSize:13}}>
                <option value="">Selecione uma conta...</option>
                {bancos.filter(b=>b.banco==="C6 Bank").map(b=><option key={b.id} value={b.id}>{b.banco} — {b.cc} — {b.titular}</option>)}
              </select>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
              {[["Client ID (OAuth2)","client_id"],["Client Secret","client_secret"],["Chave PIX (CNPJ/Email/Cel)","chave_pix"]].map(([l,k])=>(
                <div key={k} style={k==="chave_pix"?{gridColumn:"1/-1"}:{}}>
                  <label style={{color:"#94A3B8",fontSize:12,display:"block",marginBottom:4}}>{l}</label>
                  <input value={formC6[k]||""} onChange={e=>setFormC6(p=>({...p,[k]:e.target.value}))} type={k==="client_secret"?"password":"text"} placeholder={k==="client_id"?"xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx":k==="chave_pix"?"48.532.377/0001-18":""} style={{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"9px 11px",color:"#F1F5F9",fontSize:13,boxSizing:"border-box"}}/>
                </div>
              ))}
            </div>
            <div style={{marginBottom:14,padding:"12px 14px",background:"#1E3A5F",borderRadius:8,fontSize:12,color:"#94A3B8"}}>
              <div style={{color:"#3B82F6",fontWeight:600,marginBottom:6}}>ℹ️ Certificado mTLS</div>
              O C6 Bank exige um certificado digital para autenticar a API. Após obter o certificado no app C6, envie para:<br/>
              <code style={{color:"#10B981"}}>{"/home/ubuntu/erp-api/certs/" + (empAtual?.id||"EMP") + "_cert.pem"}</code><br/>
              <code style={{color:"#10B981"}}>{"/home/ubuntu/erp-api/certs/" + (empAtual?.id||"EMP") + "_key.pem"}</code>
            </div>
            <div style={{display:"flex",gap:10}}>
              <Btn onClick={salvarC6} c="#10B981" ch="✓ Salvar credenciais"/>
              {configurando&&<Btn onClick={()=>testarConexao(configurando)} c="#3B82F6" ch={testando?"Testando...":"🔌 Testar conexão"} style={{opacity:testando?0.6:1}}/>}
              {configurando&&bancos.find(b=>b.id===configurando)?.c6_configurado&&<Btn onClick={()=>registrarWebhook(configurando, formC6.chave_pix)} c="#8B5CF6" ch="📡 Registrar Webhook"/>}
            </div>
          </>}/>

          <Card style={{marginTop:16}} ch={<>
            <div style={{fontWeight:700,marginBottom:14}}>Fluxo automático após configuração</div>
            {[
              ["1","PIX recebido no C6 Bank","O pagador faz o PIX para sua chave","#3B82F6"],
              ["2","Webhook notifica o ERP","C6 envia notificação em tempo real (<1s)","#8B5CF6"],
              ["3","ERP associa ao CR","Encontra a fatura pelo valor ou txid","#F59E0B"],
              ["4","Marca como recebido","Status do CR muda para Recebido","#10B981"],
              ["5","Atualiza saldo bancário","Saldo do C6 Bank no ERP é atualizado","#10B981"],
              ["6","Libera cliente suspenso","Se havia inadimplência, reativa automaticamente","#10B981"],
            ].map(([n,t,d,c])=>(
              <div key={n} style={{display:"flex",gap:14,padding:"10px 0",borderBottom:"1px solid #1E293B",alignItems:"flex-start"}}>
                <div style={{width:28,height:28,borderRadius:"50%",background:c+"22",color:c,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:13,flexShrink:0}}>{n}</div>
                <div><div style={{fontWeight:600,fontSize:13}}>{t}</div><div style={{color:"#64748B",fontSize:12,marginTop:2}}>{d}</div></div>
              </div>
            ))}
          </>}/>
        </div>
      )}
    </div>
  );
}


// ── RELATÓRIOS PANEL ─────────────────────────────────────────────────────────
function RelatoriosPanel({dados, empAtual}) {
  const fmt2 = v => new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(v||0);
  const fmtN2 = v => new Intl.NumberFormat("pt-BR").format(v||0);

  const [tipo, setTipo] = useState("financeiro");
  const [filtros, setFiltros] = useState({dtIni:"", dtFim:"", status:"", busca:"", plano:"", cidade:""});
  const [resultado, setResultado] = useState(null);
  const ff = (k,v) => setFiltros(p=>({...p,[k]:v}));

  const cr = dados?.cr||[];
  const cp = dados?.cp||[];
  const clientes = dados?.clientes||[];
  const faturas = dados?.faturas||[];
  const conexoes = dados?.conexoes||[];
  const planos = dados?.planos_detalhados||[];
  const contratos = dados?.contratos||[];
  const frota2 = dados?.frota||[];
  const tr2 = dados?.tr||[];
  const prod2 = dados?.prod||[];

  const aplicarFiltros = (lista, campo_status, campo_data) => {
    let r = [...lista];
    if (filtros.status) r = r.filter(x => (x.st||x.status||"").toLowerCase().includes(filtros.status));
    if (filtros.busca) r = r.filter(x => JSON.stringify(x).toLowerCase().includes(filtros.busca.toLowerCase()));
    if (filtros.dtIni && campo_data) r = r.filter(x => (x[campo_data]||"") >= filtros.dtIni);
    if (filtros.dtFim && campo_data) r = r.filter(x => (x[campo_data]||"") <= filtros.dtFim);
    return r;
  };

  const gerar = () => {
    let res = {};
    if (tipo === "financeiro") {
      const crF = aplicarFiltros(cr, "st", "venc");
      const cpF = aplicarFiltros(cp, "st", "venc");
      res = {
        titulo: "Relatório Financeiro",
        cols: ["Descrição","Cliente/Fornecedor","Valor","Vencimento","Status","Tipo"],
        metricas: [
          {l:"A Receber", v:fmt2(crF.filter(x=>x.st==="pendente").reduce((a,x)=>a+(x.val||0),0)), c:"#10B981"},
          {l:"Recebido", v:fmt2(crF.filter(x=>x.st==="recebido").reduce((a,x)=>a+(x.val||0),0)), c:"#3B82F6"},
          {l:"Vencidos CR", v:fmt2(crF.filter(x=>x.st==="vencido").reduce((a,x)=>a+(x.val||0),0)), c:"#EF4444"},
          {l:"A Pagar", v:fmt2(cpF.filter(x=>x.st!=="pago").reduce((a,x)=>a+(x.val||0),0)), c:"#F59E0B"},
        ],
        rows: crF.slice(0,500).map(x=>([x.svc||x.desc||"-", x.cli||"-", fmt2(x.val), x.venc||"-", x.st||"-", x.tipo||"cr"])),
        total: crF.length,
      };
    } else if (tipo === "clientes") {
      const cliF = aplicarFiltros(clientes, "ativo", "created");
      res = {
        titulo: "Relatório de Clientes",
        cols: ["Nome","Tipo","Doc","Email","Cidade","UF","Status"],
        metricas: [
          {l:"Total", v:fmtN2(cliF.length), c:"#3B82F6"},
          {l:"Ativos", v:fmtN2(cliF.filter(c=>c.ativo).length), c:"#10B981"},
          {l:"Inativos", v:fmtN2(cliF.filter(c=>!c.ativo).length), c:"#EF4444"},
          {l:"PJ", v:fmtN2(cliF.filter(c=>c.tipo==="PJ").length), c:"#8B5CF6"},
        ],
        rows: cliF.slice(0,500).map(x=>([x.nome||"-", x.tipo||"-", x.doc||"-", x.email||"-", x.cidade||"-", x.uf||"-", x.ativo?"Ativo":"Inativo"])),
        total: cliF.length,
      };
    } else if (tipo === "inadimplencia") {
      const venc = cr.filter(x=>x.st==="vencido");
      const cliF = filtros.busca ? venc.filter(x=>JSON.stringify(x).toLowerCase().includes(filtros.busca.toLowerCase())) : venc;
      res = {
        titulo: "Relatório de Inadimplência",
        cols: ["Cliente","Serviço","Valor","Vencimento","Dias atraso"],
        metricas: [
          {l:"Inadimplentes", v:fmtN2(cliF.length), c:"#EF4444"},
          {l:"Valor total", v:fmt2(cliF.reduce((a,x)=>a+(x.val||0),0)), c:"#EF4444"},
          {l:"Ticket médio", v:fmt2(cliF.length>0?cliF.reduce((a,x)=>a+(x.val||0),0)/cliF.length:0), c:"#F59E0B"},
          {l:"% da base", v:clientes.length>0?((cliF.length/clientes.length)*100).toFixed(1)+"%":"0%", c:"#8B5CF6"},
        ],
        rows: cliF.slice(0,500).map(x=>{
          const dias = x.venc ? Math.floor((new Date()-new Date(x.venc.split("/").reverse().join("-")))/(1000*60*60*24)) : 0;
          return [x.cli||"-", x.svc||"-", fmt2(x.val), x.venc||"-", dias>0?dias+" dias":"0 dias"];
        }),
        total: cliF.length,
      };
    } else if (tipo === "faturas") {
      const fatF = aplicarFiltros(faturas, "status", "venc");
      res = {
        titulo: "Relatório de Faturas",
        cols: ["Cliente","Descrição","Valor","Vencimento","Pago em","Status","Forma pgto"],
        metricas: [
          {l:"Total faturas", v:fmtN2(fatF.length), c:"#3B82F6"},
          {l:"Pagas", v:fmtN2(fatF.filter(x=>x.status==="pago").length), c:"#10B981"},
          {l:"Vencidas", v:fmtN2(fatF.filter(x=>x.status==="vencido").length), c:"#EF4444"},
          {l:"Valor total", v:fmt2(fatF.reduce((a,x)=>a+(x.valor||0),0)), c:"#8B5CF6"},
        ],
        rows: fatF.slice(0,500).map(x=>([x.cliente||"-", x.desc||"-", fmt2(x.valor), x.venc||"-", x.pago_em||"-", x.status||"-", x.forma_pgto||"-"])),
        total: fatF.length,
      };
    } else if (tipo === "conexoes") {
      const cxF = aplicarFiltros(conexoes, "bloqueado", "cadastrado");
      const cxFilt = filtros.plano ? cxF.filter(x=>(x.plano||"").toLowerCase().includes(filtros.plano.toLowerCase())) : cxF;
      res = {
        titulo: "Relatório de Conexões Técnicas",
        cols: ["Cliente","Login PPPoE","IP","MAC","Plano","Down","Up","Status"],
        metricas: [
          {l:"Total conexões", v:fmtN2(cxFilt.length), c:"#3B82F6"},
          {l:"Ativas", v:fmtN2(cxFilt.filter(x=>!x.bloqueado).length), c:"#10B981"},
          {l:"Bloqueadas", v:fmtN2(cxFilt.filter(x=>x.bloqueado).length), c:"#EF4444"},
          {l:"Planos únicos", v:fmtN2(new Set(cxFilt.map(x=>x.plano)).size), c:"#8B5CF6"},
        ],
        rows: cxFilt.slice(0,500).map(x=>([x.cliente||"-", x.username||"-", x.ip||"-", x.mac||"-", x.plano||"-", x.vel_down||"-", x.vel_up||"-", x.bloqueado?"Bloqueado":"Ativo"])),
        total: cxFilt.length,
      };
    } else if (tipo === "cortesia") {
      const cortesia = clientes.filter(c=>{
        const temPlano = (c.plano||"").toLowerCase().includes("cortesia") || (c.obs||"").toLowerCase().includes("cortesia");
        const temZero = conexoes.find(cx=>cx.cli_id===c.id && parseFloat(cx.mensalidade||0)===0);
        return temPlano || temZero;
      });
      const cF = filtros.busca ? cortesia.filter(x=>JSON.stringify(x).toLowerCase().includes(filtros.busca.toLowerCase())) : cortesia;
      res = {
        titulo: "Relatório de Cadastros de Cortesia",
        cols: ["Nome","Tipo","Doc","Cidade","Plano","Observação","Status"],
        metricas: [
          {l:"Total cortesia", v:fmtN2(cF.length), c:"#F59E0B"},
          {l:"Ativos", v:fmtN2(cF.filter(x=>x.ativo).length), c:"#10B981"},
          {l:"% da base", v:clientes.length>0?((cF.length/clientes.length)*100).toFixed(1)+"%":"0%", c:"#8B5CF6"},
          {l:"Inativos", v:fmtN2(cF.filter(x=>!x.ativo).length), c:"#EF4444"},
        ],
        rows: cF.slice(0,500).map(x=>([x.nome||"-", x.tipo||"-", x.doc||"-", x.cidade||"-", x.plano||"-", (x.obs||"").slice(0,40)||"-", x.ativo?"Ativo":"Inativo"])),
        total: cF.length,
      };
    } else if (tipo === "planos") {
      const plF = filtros.busca ? planos.filter(x=>JSON.stringify(x).toLowerCase().includes(filtros.busca.toLowerCase())) : planos;
      const plAtivos = plF.filter(x=>x.ativo);
      res = {
        titulo: "Relatório de Planos Detalhados",
        cols: ["Nome","Vel. Down","Vel. Up","Mensalidade","Burst Down","Burst Up","Fidelidade","Status"],
        metricas: [
          {l:"Total planos", v:fmtN2(plF.length), c:"#3B82F6"},
          {l:"Ativos", v:fmtN2(plAtivos.length), c:"#10B981"},
          {l:"Ticket médio", v:fmt2(plAtivos.length>0?plAtivos.reduce((a,x)=>a+(x.mensalidade||0),0)/plAtivos.length:0), c:"#8B5CF6"},
          {l:"Receita potencial", v:fmt2(plAtivos.reduce((a,x)=>a+(x.mensalidade||0),0)), c:"#F59E0B"},
        ],
        rows: plF.slice(0,500).map(x=>([x.nome||"-", x.vel_down||"-", x.vel_up||"-", fmt2(x.mensalidade), x.burst_down||"-", x.burst_up||"-", (x.meses_fidelidade||0)+" meses", x.ativo?"Ativo":"Inativo"])),
        total: plF.length,
      };
    } else if (tipo === "contratos") {
      const ctF = aplicarFiltros(contratos, "status", "inicio");
      res = {
        titulo: "Relatório de Contratos",
        cols: ["Número","Cliente","Plano","Login PPPoE","IP","Venc. dia","Status"],
        metricas: [
          {l:"Total", v:fmtN2(ctF.length), c:"#3B82F6"},
          {l:"Ativos", v:fmtN2(ctF.filter(x=>x.status==="ativo").length), c:"#10B981"},
          {l:"Cancelados", v:fmtN2(ctF.filter(x=>x.status==="cancelado").length), c:"#EF4444"},
          {l:"Com login PPPoE", v:fmtN2(ctF.filter(x=>x.login_pppoe).length), c:"#8B5CF6"},
        ],
        rows: ctF.slice(0,500).map(x=>([x.numero||"-", x.cliente||"-", x.plano||"-", x.login_pppoe||"-", x.ip||"-", "dia "+( x.venc_dia||"-"), x.status||"-"])),
        total: ctF.length,
      };
    }
    setResultado(res);
  };

  const exportarCSV = () => {
    if (!resultado) return;
    const csv = [resultado.cols.join(";"), ...resultado.rows.map(r=>r.join(";"))].join("\n");
    const a = document.createElement("a");
    a.href = "data:text/csv;charset=utf-8,\uFEFF" + encodeURIComponent(csv);
    a.download = "relatorio_" + tipo + "_" + new Date().toISOString().slice(0,10) + ".csv";
    a.click();
  };

  const imprimir = () => window.print();

  const TIPOS = [
    ["financeiro","💰","Financeiro"],["clientes","👥","Clientes"],
    ["inadimplencia","⚠️","Inadimplência"],["faturas","📄","Faturas"],
    ["conexoes","🔌","Conexões Técnicas"],["cortesia","🎁","Cortesia"],
    ["planos","📡","Planos"],["contratos","📋","Contratos"],
  ];

  return (
    <div>
      <div style={{marginBottom:20}}>
        <h1 style={{fontSize:20,fontWeight:800}}>Relatórios</h1>
        <div style={{color:"#64748B",fontSize:12}}>Filtros livres · Exportação CSV/Excel/PDF · Dados reais da empresa</div>
      </div>

      {/* Seletor de tipo */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:20}}>
        {TIPOS.map(([id,ic,lb])=>(
          <div key={id} onClick={()=>setTipo(id)} style={{padding:"10px 12px",borderRadius:8,cursor:"pointer",border:`1px solid ${tipo===id?"#3B82F6":"#334155"}`,background:tipo===id?"#1E3A5F":"#1E293B",display:"flex",alignItems:"center",gap:8,fontSize:13,fontWeight:tipo===id?700:400,color:tipo===id?"#3B82F6":"#94A3B8"}}>
            <span>{ic}</span><span>{lb}</span>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <Card style={{marginBottom:16}} ch={<>
        <div style={{fontWeight:600,fontSize:13,marginBottom:12,color:"#94A3B8"}}>🔍 Filtros</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
          <div>
            <label style={{color:"#64748B",fontSize:11,display:"block",marginBottom:4}}>Período início</label>
            <input type="date" value={filtros.dtIni} onChange={e=>ff("dtIni",e.target.value)} style={{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"7px 10px",color:"#F1F5F9",fontSize:13,boxSizing:"border-box"}}/>
          </div>
          <div>
            <label style={{color:"#64748B",fontSize:11,display:"block",marginBottom:4}}>Período fim</label>
            <input type="date" value={filtros.dtFim} onChange={e=>ff("dtFim",e.target.value)} style={{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"7px 10px",color:"#F1F5F9",fontSize:13,boxSizing:"border-box"}}/>
          </div>
          <div>
            <label style={{color:"#64748B",fontSize:11,display:"block",marginBottom:4}}>Status</label>
            <select value={filtros.status} onChange={e=>ff("status",e.target.value)} style={{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"7px 10px",color:"#F1F5F9",fontSize:13}}>
              <option value="">Todos</option>
              <option value="ativo">Ativo</option>
              <option value="inativo">Inativo</option>
              <option value="pendente">Pendente</option>
              <option value="pago">Pago</option>
              <option value="vencido">Vencido</option>
              <option value="recebido">Recebido</option>
              <option value="bloqueado">Bloqueado</option>
              <option value="cancelado">Cancelado</option>
            </select>
          </div>
          <div>
            <label style={{color:"#64748B",fontSize:11,display:"block",marginBottom:4}}>Busca livre</label>
            <input value={filtros.busca} onChange={e=>ff("busca",e.target.value)} placeholder="Nome, CPF, IP, login..." style={{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"7px 10px",color:"#F1F5F9",fontSize:13,boxSizing:"border-box"}}/>
          </div>
          <div>
            <label style={{color:"#64748B",fontSize:11,display:"block",marginBottom:4}}>Plano</label>
            <input value={filtros.plano} onChange={e=>ff("plano",e.target.value)} placeholder="Ex: Fibra 300MB" style={{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"7px 10px",color:"#F1F5F9",fontSize:13,boxSizing:"border-box"}}/>
          </div>
          <div style={{display:"flex",alignItems:"flex-end",gap:8}}>
            <Btn onClick={gerar} c="#3B82F6" full ch="▶ Gerar relatório"/>
            <Btn onClick={()=>{setFiltros({dtIni:"",dtFim:"",status:"",busca:"",plano:"",cidade:""});setResultado(null);}} out c="#64748B" ch="✕"/>
          </div>
        </div>
      </>}/>

      {/* Resultado */}
      {resultado&&(
        <div>
          {/* Métricas */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:16}}>
            {resultado.metricas.map(m=>(
              <Card key={m.l} ch={<>
                <div style={{color:"#94A3B8",fontSize:12,marginBottom:4}}>{m.l}</div>
                <div style={{fontWeight:700,fontSize:20,color:m.c}}>{m.v}</div>
              </>}/>
            ))}
          </div>

          {/* Barra de ações */}
          <Card ch={<>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:10}}>
              <div>
                <span style={{fontWeight:700,fontSize:14}}>{resultado.titulo}</span>
                <span style={{color:"#64748B",fontSize:12,marginLeft:10}}>{fmtN2(resultado.total)} registros</span>
                {resultado.total>500&&<span style={{color:"#F59E0B",fontSize:11,marginLeft:8}}>(exibindo 500 de {fmtN2(resultado.total)})</span>}
              </div>
              <div style={{display:"flex",gap:8}}>
                <Btn sm onClick={exportarCSV} c="#10B981" ch="⬇ CSV"/>
                <Btn sm onClick={()=>{exportarCSV();}} c="#8B5CF6" ch="📊 Excel"/>
                <Btn sm onClick={imprimir} c="#3B82F6" ch="🖨️ Imprimir/PDF"/>
              </div>
            </div>
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                <thead>
                  <tr style={{borderBottom:"1px solid #334155"}}>
                    {resultado.cols.map(c=><th key={c} style={{textAlign:"left",padding:"7px 10px",color:"#64748B",fontWeight:600,whiteSpace:"nowrap"}}>{c}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {resultado.rows.length===0&&(
                    <tr><td colSpan={resultado.cols.length} style={{padding:32,textAlign:"center",color:"#475569"}}>Nenhum registro encontrado com os filtros aplicados</td></tr>
                  )}
                  {resultado.rows.map((r,i)=>(
                    <tr key={i} style={{borderBottom:"1px solid #1E293B",background:i%2===0?"transparent":"#0F172A33"}}>
                      {r.map((c,j)=>(
                        <td key={j} style={{padding:"8px 10px",color:"#F1F5F9",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:200}}>
                          {c}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>}/>
        </div>
      )}

      {!resultado&&(
        <Card style={{textAlign:"center",padding:60}} ch={<>
          <div style={{fontSize:48,marginBottom:16}}>📊</div>
          <div style={{fontWeight:700,fontSize:18,marginBottom:8}}>Selecione o tipo e clique em Gerar</div>
          <div style={{color:"#64748B",fontSize:13,maxWidth:400,margin:"0 auto"}}>
            Escolha o tipo de relatório, aplique os filtros desejados e clique em <strong style={{color:"#3B82F6"}}>▶ Gerar relatório</strong> para ver os dados reais da empresa.
          </div>
        </>}/>
      )}
    </div>
  );
}

export default function App() {
  const [tela,setTela] = useState("landing");
  const [user,setUser] = useState(null);

  const onLogin = (d) => {
    if(d?.token){ setUser(d); setTela("erp"); }
    else setTela("erp");
  };

  if(tela==="landing") return <Landing onGo={()=>setTela("login")}/>;
  if(tela==="login") return <Login onLogin={onLogin}/>;
  if(tela==="erp") return <ERP user={user} onLogout={()=>{setUser(null);setTela("landing");}}/>;
}
